import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const PeekabooGallery = () => {
  const images = [
    { 
      src: "/lovable-uploads/bc9b63a6-0317-4017-9dc2-64e39276043c.png", 
      alt: "Peekaboo Early Gender DNA Test Logo" 
    },
    { 
      src: "/lovable-uploads/26691c18-e5a4-4d7d-a2b0-36a3fb7fbd77.png", 
      alt: "Peekaboo PRO Test Kit - Now Offering" 
    },
    { 
      src: "/lovable-uploads/53278547-3563-4252-b92a-12395b9d7217.png", 
      alt: "Healthcare Provider Test Kit" 
    },
    { 
      src: "/lovable-uploads/b7de9bf5-e4e6-4531-bcca-ca311f5cb6a0.png", 
      alt: "Blood Draw Process" 
    },
    { 
      src: "/lovable-uploads/3594e086-1746-4615-8a53-31b92ade1b01.png", 
      alt: "Test Kit Contents" 
    },
    { 
      src: "/lovable-uploads/ee46e638-25b4-4d54-937a-fe40903e51f1.png", 
      alt: "Results Celebration" 
    },
    { 
      src: "/lovable-uploads/386dbec7-5b46-4137-9cc0-26c0a2491b56.png", 
      alt: "Boy or Girl? Don't wait for your ultrasound" 
    },
    { 
      src: "/lovable-uploads/f1935be5-c99f-4794-b469-3da8da8f7fd2.png", 
      alt: "Over 99% Accurate, Fast Results, Affordable Testing" 
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);

  const nextImage = () => {
    if (isFlipping) return;
    setIsFlipping(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      setIsFlipping(false);
    }, 150);
  };

  const prevImage = () => {
    if (isFlipping) return;
    setIsFlipping(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      setIsFlipping(false);
    }, 150);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full max-w-2xl mx-auto bg-card rounded-xl shadow-lg overflow-hidden">
      <div className="relative aspect-[16/10] bg-gradient-to-br from-purple-100 via-pink-50 to-blue-100">
        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          className={`w-full h-full object-contain transition-all duration-300 ${
            isFlipping ? 'scale-95 opacity-70' : 'scale-100 opacity-100'
          }`}
        />
        
        {/* Navigation Buttons */}
        <button
          onClick={prevImage}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-700 p-2 rounded-full shadow-md transition-all duration-200 hover:scale-110"
          aria-label="Previous image"
        >
          <ChevronLeft size={20} />
        </button>
        
        <button
          onClick={nextImage}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-700 p-2 rounded-full shadow-md transition-all duration-200 hover:scale-110"
          aria-label="Next image"
        >
          <ChevronRight size={20} />
        </button>

        {/* Dots Indicator */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                if (!isFlipping) {
                  setIsFlipping(true);
                  setTimeout(() => {
                    setCurrentIndex(index);
                    setIsFlipping(false);
                  }, 150);
                }
              }}
              className={`w-2 h-2 rounded-full transition-all duration-200 ${
                index === currentIndex
                  ? 'bg-purple-600 scale-125'
                  : 'bg-white/60 hover:bg-white/80'
              }`}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      </div>
      
      {/* Image Caption */}
      <div className="p-4 text-center">
        <p className="text-sm text-muted-foreground">{images[currentIndex].alt}</p>
      </div>
    </div>
  );
};

export default PeekabooGallery;